import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import apiClient from '@/utils/api';
import { Sparkles, MapPin, IndianRupee, Loader2, Home } from 'lucide-react';

const RecommendedProperties = () => {
  const navigate = useNavigate();
  const [data, setData] = useState({ properties: [], source: '', message: '' });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    apiClient.get('/properties/recommended')
      .then(res => setData(res.data))
      .catch(() => setData({ properties: [], source: 'error' }))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="flex justify-center py-8"><Loader2 className="w-6 h-6 animate-spin text-gray-400" /></div>;
  if (data.source === 'disabled') return null;

  const sourceLabel = data.source === 'preferences' ? 'Based on your preferences' : data.source === 'popular' ? 'Popular Properties' : data.source === 'latest' ? 'Latest Listings' : '';

  return (
    <div className="mt-8" data-testid="recommended-properties-section">
      <div className="flex items-center gap-3 mb-4">
        <Sparkles className="w-6 h-6 text-[#15803D]" />
        <div>
          <h2 className="text-2xl">Recommended for You</h2>
          {sourceLabel && <p className="text-xs text-gray-500">{sourceLabel}</p>}
        </div>
      </div>

      {data.properties.length === 0 ? (
        <div className="bg-white p-8 text-center" data-testid="recommended-empty-state">
          <Home className="w-10 h-10 mx-auto text-gray-300 mb-3" />
          <p className="text-gray-600">{data.message || 'Start exploring properties to receive personalized recommendations.'}</p>
          <p className="text-sm text-gray-400 mt-2">Update your preferences to get tailored suggestions.</p>
        </div>
      ) : (
        <div className="grid md:grid-cols-3 gap-6">
          {data.properties.slice(0, 6).map(property => (
            <div key={property.property_id} className="bg-white p-6 cursor-pointer hover:shadow-lg transition-all border-l-4 border-[#15803D]" onClick={() => navigate(`/property/${property.property_id}`)} data-testid={`recommended-${property.property_id}`}>
              <h3 className="text-lg font-semibold mb-1 line-clamp-1">{property.title}</h3>
              <div className="flex items-center gap-1 text-sm text-gray-600 mb-2">
                <MapPin className="w-4 h-4" />
                {property.city}{property.locality ? `, ${property.locality}` : ''}
              </div>
              <div className="flex items-center justify-between">
                <span className="text-xs px-2 py-0.5 bg-gray-100 text-gray-600 rounded">{property.property_type}</span>
                <p className="font-mono text-lg text-[#15803D]">
                  <IndianRupee className="w-3.5 h-3.5 inline" />
                  {property.price >= 10000000 ? `${(property.price / 10000000).toFixed(2)} Cr` : `${(property.price / 100000).toFixed(2)} L`}
                </p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default RecommendedProperties;
